<template>
  <el-dialog
    title="设置成员权限"
    :visible.sync="value.visible"
    width="700px"
    :destroy-on-close="true"
    @open="onDlgOpen"
  >
    <div v-loading="$store.state.app.loadingList.includes('updateFormUser')" class="">
      <!-- <div class="mb-2_5">设置权限</div> -->
      <el-radio-group v-model="role" @change="onOk">
        <div v-for="(element) in roleText" :key="element.value" class="my-2_5">
          <el-radio :label="element.value" border style="width:100%;">{{ element.text }}</el-radio>
        </div>
      </el-radio-group>
    </div>

    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onOk">确 定</el-button>
    </span> -->
  </el-dialog>

</template>

<script>
import { updateFormUser } from '@/api/form'

export default {
  name: 'DlgSetMem',
  components: {
  },
  props: {
    // 原则上vue的props应该是只读的，但vue对对象中的内容没有监测，这里不管了，直接把modelValue当作可写的
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({
        item: null
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      role: 0,
      roleText: [
        {
          text: '属主',
          value: 1
        },
        {
          text: '协管',
          value: 2
        }
      ]
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
    console.log(this.role)
  },

  methods: {
    onDlgOpen() {
      this.role = this.params.item?.role || 2
    },
    async saveForm() {
      const that = this

      const res = await updateFormUser({
        form_id: that.params.item.form_id,
        user_id: that.params.item.user_id,
        role: that.role
      }, 'updateFormUser')
      console.log(res)

      return res
    },

    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      const that = this
      try {
        // unhandledrejection处理函数没有捕获saveForm可能抛出的异常，此处捕获一下，免得报错
        console.log('ok')

        await that.saveForm()
        that.value.visible = false
        that.$emit('ok', this.value)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
